import NavBar from '../components/NavBar';
import Brief from '../components/Brief';
import ROS from '../components/RevealOnScroll';
import WhatWeMade from '../components/WhatWeMade';
import { useTranslation } from "react-i18next";
import Cooperations from '../components/Cooperations';

export default function MainPage() {
  const { t } = useTranslation();
  return (
    <>
      <div class="grid px-4 pb-8">
        <Brief name={t("about_us")} brief={t("about_brief")} />
        <ROS><WhatWeMade/></ROS>
        <ROS><Brief name={t("hystory")} brief={t("hystory_brief")} /></ROS>
        { /*TODO přidat všechny kooperace <Cooperations/> */}
      </div>
      <NavBar/>  {/*je až nakonci aby byl opravdu nad všemi elementy */}
    </>
  )
}